/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Taggroups_Epicfeature1Inputs */

const id_search_taggroups_epicfeature1 = /** @type {(inputs: Search_Taggroups_Epicfeature1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fitur Epic`)
};

const ms_search_taggroups_epicfeature1 = /** @type {(inputs: Search_Taggroups_Epicfeature1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ciri Epic`)
};

const da_search_taggroups_epicfeature1 = /** @type {(inputs: Search_Taggroups_Epicfeature1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Funktion`)
};

const de_search_taggroups_epicfeature1 = /** @type {(inputs: Search_Taggroups_Epicfeature1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic-Funktion`)
};

const en_us2_search_taggroups_epicfeature1 = /** @type {(inputs: Search_Taggroups_Epicfeature1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Feature`)
};

const es_es2_search_taggroups_epicfeature1 = /** @type {(inputs: Search_Taggroups_Epicfeature1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Característica de Epic`)
};

const es_mx2_search_taggroups_epicfeature1 = /** @type {(inputs: Search_Taggroups_Epicfeature1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Característica de Epic`)
};

const fil_search_taggroups_epicfeature1 = /** @type {(inputs: Search_Taggroups_Epicfeature1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Feature`)
};

const fr_search_taggroups_epicfeature1 = /** @type {(inputs: Search_Taggroups_Epicfeature1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fonctionnalité Epic`)
};

const it_search_taggroups_epicfeature1 = /** @type {(inputs: Search_Taggroups_Epicfeature1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caratteristica Epic`)
};

const hu_search_taggroups_epicfeature1 = /** @type {(inputs: Search_Taggroups_Epicfeature1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic funkció`)
};

const nl_search_taggroups_epicfeature1 = /** @type {(inputs: Search_Taggroups_Epicfeature1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic-functie`)
};

const no_search_taggroups_epicfeature1 = /** @type {(inputs: Search_Taggroups_Epicfeature1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic-funksjon`)
};

const pl_search_taggroups_epicfeature1 = /** @type {(inputs: Search_Taggroups_Epicfeature1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funkcja Epic`)
};

const pt_br2_search_taggroups_epicfeature1 = /** @type {(inputs: Search_Taggroups_Epicfeature1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recurso épico`)
};

const pt_search_taggroups_epicfeature1 = /** @type {(inputs: Search_Taggroups_Epicfeature1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funcionalidade Epic`)
};

const ro_search_taggroups_epicfeature1 = /** @type {(inputs: Search_Taggroups_Epicfeature1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caracteristică Epic`)
};

const fi_search_taggroups_epicfeature1 = /** @type {(inputs: Search_Taggroups_Epicfeature1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic-ominaisuus`)
};

const sv_search_taggroups_epicfeature1 = /** @type {(inputs: Search_Taggroups_Epicfeature1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic-funktion`)
};

const vi_search_taggroups_epicfeature1 = /** @type {(inputs: Search_Taggroups_Epicfeature1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tính năng Epic`)
};

const tr_search_taggroups_epicfeature1 = /** @type {(inputs: Search_Taggroups_Epicfeature1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Özelliği`)
};

const cs_search_taggroups_epicfeature1 = /** @type {(inputs: Search_Taggroups_Epicfeature1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funkce Epic`)
};

const bg_search_taggroups_epicfeature1 = /** @type {(inputs: Search_Taggroups_Epicfeature1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic функция`)
};

const ru_search_taggroups_epicfeature1 = /** @type {(inputs: Search_Taggroups_Epicfeature1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Функция Epic`)
};

const uk_search_taggroups_epicfeature1 = /** @type {(inputs: Search_Taggroups_Epicfeature1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Функція Epic`)
};

const ar_search_taggroups_epicfeature1 = /** @type {(inputs: Search_Taggroups_Epicfeature1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ميزة Epic`)
};

const hi_search_taggroups_epicfeature1 = /** @type {(inputs: Search_Taggroups_Epicfeature1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic फ़ीचर`)
};

const th_search_taggroups_epicfeature1 = /** @type {(inputs: Search_Taggroups_Epicfeature1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ฟีเจอร์ของ Epic`)
};

const ja_search_taggroups_epicfeature1 = /** @type {(inputs: Search_Taggroups_Epicfeature1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic 機能`)
};

const zh_cn2_search_taggroups_epicfeature1 = /** @type {(inputs: Search_Taggroups_Epicfeature1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic功能`)
};

const zh_hant1_search_taggroups_epicfeature1 = /** @type {(inputs: Search_Taggroups_Epicfeature1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic功能`)
};

const ko_search_taggroups_epicfeature1 = /** @type {(inputs: Search_Taggroups_Epicfeature1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic 기능`)
};

/**
* | output |
* | --- |
* | "Epic Feature" |
*
* @param {Search_Taggroups_Epicfeature1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const search_taggroups_epicfeature1 = /** @type {((inputs?: Search_Taggroups_Epicfeature1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Taggroups_Epicfeature1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_search_taggroups_epicfeature1(inputs)
	if (locale === "ms") return ms_search_taggroups_epicfeature1(inputs)
	if (locale === "da") return da_search_taggroups_epicfeature1(inputs)
	if (locale === "de") return de_search_taggroups_epicfeature1(inputs)
	if (locale === "en-US") return en_us2_search_taggroups_epicfeature1(inputs)
	if (locale === "es-ES") return es_es2_search_taggroups_epicfeature1(inputs)
	if (locale === "es-MX") return es_mx2_search_taggroups_epicfeature1(inputs)
	if (locale === "fil") return fil_search_taggroups_epicfeature1(inputs)
	if (locale === "fr") return fr_search_taggroups_epicfeature1(inputs)
	if (locale === "it") return it_search_taggroups_epicfeature1(inputs)
	if (locale === "hu") return hu_search_taggroups_epicfeature1(inputs)
	if (locale === "nl") return nl_search_taggroups_epicfeature1(inputs)
	if (locale === "no") return no_search_taggroups_epicfeature1(inputs)
	if (locale === "pl") return pl_search_taggroups_epicfeature1(inputs)
	if (locale === "pt-BR") return pt_br2_search_taggroups_epicfeature1(inputs)
	if (locale === "pt") return pt_search_taggroups_epicfeature1(inputs)
	if (locale === "ro") return ro_search_taggroups_epicfeature1(inputs)
	if (locale === "fi") return fi_search_taggroups_epicfeature1(inputs)
	if (locale === "sv") return sv_search_taggroups_epicfeature1(inputs)
	if (locale === "vi") return vi_search_taggroups_epicfeature1(inputs)
	if (locale === "tr") return tr_search_taggroups_epicfeature1(inputs)
	if (locale === "cs") return cs_search_taggroups_epicfeature1(inputs)
	if (locale === "bg") return bg_search_taggroups_epicfeature1(inputs)
	if (locale === "ru") return ru_search_taggroups_epicfeature1(inputs)
	if (locale === "uk") return uk_search_taggroups_epicfeature1(inputs)
	if (locale === "ar") return ar_search_taggroups_epicfeature1(inputs)
	if (locale === "hi") return hi_search_taggroups_epicfeature1(inputs)
	if (locale === "th") return th_search_taggroups_epicfeature1(inputs)
	if (locale === "ja") return ja_search_taggroups_epicfeature1(inputs)
	if (locale === "zh-CN") return zh_cn2_search_taggroups_epicfeature1(inputs)
	if (locale === "zh-Hant") return zh_hant1_search_taggroups_epicfeature1(inputs)
	return ko_search_taggroups_epicfeature1(inputs)
});
export { search_taggroups_epicfeature1 as "search.tagGroups.epicfeature" }